<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-file-document-outline</v-icon>
        <h1 class="page-title">{{ document.title }}</h1>
      </v-layout>
    </div>
    <h2></h2>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>{{ document.filename }}</v-card-title>
          <v-card-text>
            <div
              v-if="document.extension === 'jpg'"
              :style="`transform: rotate(${rotation}deg);`"
            >
              <span
                style="padding-right: 5px; padding-top: 5px; display:inline-block;"
              >
                <img
                  :aspect-ratio="16 / 9"
                  height="800"
                  width="800"
                  :src="`data:image/jpeg;base64,` + document.documentContent"
                />
              </span>
            </div>
            <div v-if="document.extension === 'pdf'">
              Sorry pdf's can't currently be displayed
            </div>
          </v-card-text>
          <v-card-actions>
            <div v-if="document.extension === 'jpg'">
              <v-row>
                <v-col cols="12" lg="6" md="6" sm="6">
                  <v-btn
                    class="button"
                    outlined
                    @click="rotateLeft"
                  >
                    <v-icon>mdi-rotate-left</v-icon>
                    rotate left
                  </v-btn>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="6">
                  <v-btn
                    class="button"
                    outlined
                    @click="rotateRight"
                  >
                    <v-icon>mdi-rotate-right</v-icon>
                    rotate right
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DocumentService from '../../services/api/DocumentsService'
import store from '@/store/index.js'

export default {
  name: 'document-view',

  store: store,

  data() {
    return {
      document: {
        title: '',
        filename: '',
        extension: ''
      },
      rotation: 0
    }
  },

  created() {
    if (this.$route.params.documentId > 0) {
      store.commit('isLoading')
      DocumentService.getDocument(this.$route.params.documentId)
        .then(data => {
          this.document = data
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    }
  },

  methods: {
    rotateRight() {
      this.rotation -= 90
    },
    rotateLeft() {
      this.rotation += 90
    }
  }
}
</script>
